import { getCountryCodes } from 'Core/data/Helpers';

export const splitPhoneNumber = (input) => {
    if (typeof input !== 'string' || !input.startsWith('+') || input.length < 11) {
      return { indicativo: null, phone: input };
    }
  
    const phone = input.slice(-10); 
    const countryCode = input.slice(1, input.length - 10);
  
    return { countryCode, phone };
  }

export const getCountryCodeById = (id) => {
    const countries = getCountryCodes();
    return countries.find(country => country.id === id);
}

export const getEntityById = (id, list) => {
    return list.find(item => item.entityId == id);
}

export const validateLicenseState = (formData) => {
    const { licenseCountry, licenseState } = formData;
    let licenseStateValue = null;
    if(licenseCountry?.entityId === 'US' || licenseCountry?.entityId === 'CA'){
        licenseStateValue = licenseState?.entityId;
    } else{
        licenseStateValue = licenseCountry?.entityId;
    }
    return { licenseCountry: licenseCountry?.entityId, licenseState: licenseStateValue};
}